import { useEffect, useState } from "react";
import usePaginator from "../../../theme/Component/usePaginator";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _AccountINFORPO, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { CardTaps } from "../../../theme/Component/CardTaps";
import { DropDown } from "../../../theme/Component/DropDown";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";

interface Props {
    Credit: any;
}

export const ThirdCreditsInforpoDetails = ({ Credit }: Props) => {

    const paginador = usePaginator();
    const [indexTap, setIndexTap] = useState(0);
    const { instance, bean, setBean, lista, setLista } = useDataBean(_AccountINFORPO);

    const taps = [
        { id: 0, name: 'Amortización del Credito', disable: false },
        { id: 1, name: 'Historial del Credito', disable: false }
    ];

    useEffect(() => {
        setLista([])
        if (indexTap === 0) {
            getAmortization()
        } else if (indexTap === 1) {
            getHistory()
        }
    }, [indexTap, paginador.page]);

    useEffect(() => {
        if (paginador.page != 1) {
            paginador.setPage(1);
        }
    }, [indexTap])

    const [listaExport, setListaExport] = useState([]);

    const getListaExport = () => {
        // functionalArea.instance.getFunctionalAreaCatalogvdos(IDLn, formResponse.State, formResponse.Name, formResponse.IDLnFunctional, formResponse.Appointment, formResponse.StateContract, formResponse.IDAccount, date, 1, paginador.pages * 15).then(
        const props = {
            CREDITO_ID: Credit.CREDITO_ID
        }
        if (indexTap === 0) {
            instance.getCuotasCreditoInforpo(1, paginador.pages * 15, props).then(
                (resp) => {
                    setListaExport(resp.List);
                }
            ).catch(
                err => {
                    console.log(err)
                }
            )
        } else if (indexTap === 1) {
            instance.getHistoriaCreditoInforpo(1, paginador.pages * 15, props).then(
                (resp) => {
                    setListaExport(resp.List)
                }
            ).catch(
                err => {
                    console.log(err)
                }
            )
        }
    }

    const modalcsv = useModal("Exportar Listado", MODAL_SM)

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }
                </div>
            </div>
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
    ];

    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            modalcsv.open();
        }
    }

    const getHistory = () => {
        const props = {
            CREDITO_ID: Credit.CREDITO_ID
        }
        instance.getHistoriaCreditoInforpo(paginador.page, 15, props).then(
            (resp) => {
                setLista(resp.List)
                paginador.setPages(resp.NumberOfPages);
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const getAmortization = () => {
        const props = {
            CREDITO_ID: Credit.CREDITO_ID
        }
        instance.getCuotasCreditoInforpo(paginador.page, 15, props).then(
            (resp) => {
                setLista(resp.List)
                paginador.setPages(resp.NumberOfPages);
            }
        ).catch(
            err => {
                console.log(err)
            }
        )

    }

    const headHistory = [
        { title: 'ID', property: 'CREDITO_HISTORIA_ID', visible: true, mask: MASK_NUMBER },
        { title: 'Cuotas Pagadas', property: 'CUOTAS_PAGADAS', visible: true, mask: MASK_NUMBER },
        
        { title: 'Periodo', property: 'PERIODO', visible: true, mask: MASK_NUMBER },
        { title: 'Pago Periodo', property: 'PAGO_PERIODO', visible: true,mask:MASK_MONEY },
        
        { title: 'Pago Capital', property: 'PAGO_CAPITAL', visible: true,mask:MASK_MONEY },
        { title: 'Pago Interes Corriente', property: 'PAGO_INTERES_CORRIENTE', visible: true,mask:MASK_MONEY },
        { title: 'Pago Interes Mora', property: 'PAGO_INTERES_MORA', visible: true,mask:MASK_MONEY },
        
        { title: 'Saldo Capital', property: 'SALDO_CAPITAL', visible: true,mask:MASK_MONEY },
        { title: 'Saldo Capital Mora', property: 'SALDO_MORA_CAPITAL', visible: true,mask:MASK_MONEY },
        { title: 'Saldo Interes Mora', property: 'SALDO_INTERES_MORA', visible: true,mask:MASK_MONEY },
        { title: 'Fecha ultimo pago', property: 'FECHA_ULTIMO_PAGO', visible: true,mask:MASK_DATE },
        
    ]

    const headAmortizacion = [
        { title: 'ID', property: 'CUOTA_CREDITO_ID', visible: true, mask: MASK_NUMBER },
        { title: 'Cuota', property: 'NUMERO_CUOTA', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha de Cuota', property: 'FECHA_CUOTA', visible: true, mask: MASK_DATE },
        { title: 'Tasa de Interes Variable', property: 'TASA_INTERES_VARIABLE', visible: false },
        { title: 'Capital', property: 'VALOR_CAPITAL', visible: true, mask: MASK_MONEY },
        { title: 'Valor de la Cuota', property: 'VALOR_CUOTA', visible: true, mask: MASK_MONEY },
        { title: 'Tasa de Interes Fijo', property: 'VALOR_INTERES_FIJO', visible: true, mask: MASK_MONEY },
        { title: 'Tasa de Interes Variables', property: 'VALOR_INTERES_VARIABLE', visible: false, mask: MASK_MONEY },
        { title: 'Saldo de Capital', property: 'SALDO_CAPITAL', visible: true, mask: MASK_MONEY },
    ]



    return (
        <div className="row">
            <div className="col-md-12">
                <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap}>
                    <div className="row">
                        {indexTap === 0 &&
                            <div className="col-md-12">
                                <BasicTable
                                    headButtons={buttons()}
                                    body={lista}
                                    head={headAmortizacion}
                                    rowSet={setBean}
                                    pageTop={paginador.page}
                                    next={paginador.next}
                                    back={paginador.back}
                                    records={paginador}
                                />
                            </div>
                        }
                        {indexTap === 1 &&
                            <div className="col-md-12">
                                <BasicTable
                                    headButtons={buttons()}
                                    body={lista}
                                    head={headHistory}
                                    rowSet={setBean}
                                    pageTop={paginador.page}
                                    next={paginador.next}
                                    back={paginador.back}
                                    records={paginador}
                                />
                            </div>
                        }

                    </div>
                </CardTaps>
            </div>

            <div className="col-md-12">
                <Modal modal={modalcsv.modal} updateModal={modalcsv.setModal}>
                    <div className="row">
                        <div className="col">
                            {lista.length > 0 &&
                                <ExportXLSL customName={`${indexTap === 0 ? "Amortizaciones" : "Historial"}`} optionIcon="ri-download-cloud-2-line text-success" title={indexTap === 0 ? headAmortizacion : headHistory} data={listaExport} onExport={(name: string) => {
                                    _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                }} />
                            }
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}